import React from 'react'
import flask from '../static/graphics/skills/Flask.png'
import spring from '../static/graphics/skills/spring.png'
import jinja from '../static/graphics/skills/jinja.png'
import npm from '../static/graphics/skills/npm.png'
import react from '../static/graphics/skills/react.png'
import svelte from '../static/graphics/skills/svelte.png'
import node from '../static/graphics/skills/node.png'
import psql from '../static/graphics/skills/psql.png'
import mongodb from '../static/graphics/skills/mongodb.png'
import threeJs from '../static/graphics/skills/threejs.png'

export const FrameworksData = [
    {
        name: "Flask",
        image: flask
    },
    {
        name: "Jinja",
        image: jinja
    },
    {
        name: "React",
        image: react
    },
    {
        name: "Svelte",
        image: svelte
    },
    {
        name: "Spring",
        image: spring
    },
    {
        name: "npm",
        image: npm
    },
    {
        name: "NodeJs",
        image: node
    },
    {
        name: "MongoDB",
        image: mongodb
    },
    {
        name: "PSQL",
        image: psql
    },
    {
        name: "ThreeJs",
        image: threeJs
    }
]